import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-node-col" }
const _hoisted_2 = {
  key: 0,
  class: "shopping-cart-empty"
}
const _hoisted_3 = { style: {"max-width":"500px","text-align":"center"} }
const _hoisted_4 = {
  key: 1,
  class: "shopping-cart-empty"
}
const _hoisted_5 = {
  key: 2,
  class: "flex-node-col shopping-cart-body"
}
const _hoisted_6 = {
  key: 0,
  class: "expired-warning"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-save" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-link-horizontal" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "flex-container-row align-center centered"
}
const _hoisted_10 = ["checked", "onChange"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  style: {"font-size":"smaller"}
}
const _hoisted_13 = {
  key: 2,
  class: "flex-container-row gap5"
}
const _hoisted_14 = {
  key: 0,
  style: {"align-self":"center"}
}
const _hoisted_15 = { style: {"align-self":"center"} }
const _hoisted_16 = {
  key: 3,
  class: "cart-picture-cell"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "flex-container-row align-center gap5"
}
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "cart-picture-cell-narrow"
}
const _hoisted_23 = {
  class: "flex-container-col gap5",
  style: {"flex":"1","min-width":"0"}
}
const _hoisted_24 = { class: "flex-container-col" }
const _hoisted_25 = { class: "flex-container-row" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "grid-id-link" }
const _hoisted_29 = {
  key: 0,
  class: "cart-partner-material"
}
const _hoisted_30 = {
  key: 1,
  class: "flex-container-col"
}
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "flex-container-row gap5" }
const _hoisted_33 = {
  key: 2,
  class: "flex-container-row gap5"
}
const _hoisted_34 = { style: {"align-self":"center"} }
const _hoisted_35 = {
  key: 3,
  style: {"font-size":"smaller"}
}
const _hoisted_36 = {
  key: 4,
  class: "flex-container-col"
}
const _hoisted_37 = { class: "font-bold" }
const _hoisted_38 = {
  key: 0,
  class: "flex-item flex-container-row shopping-cart-total"
}
const _hoisted_39 = { style: {"margin-left":"auto"} }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  style: {"flex-grow":"1"}
}
const _hoisted_42 = {
  key: 2,
  style: {"flex-grow":"1"}
}
const _hoisted_43 = { key: 3 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_45 = { style: {"margin":"25px","text-align":"center"} }
const _hoisted_46 = { style: {"margin":"25px","text-align":"center","max-width":"400px"} }
const _hoisted_47 = {
  style: {"padding":"16px 24px","min-width":"380px","text-align":"left"},
  class: "flex-container-col gap10"
}
const _hoisted_48 = {
  class: "flex-container-col",
  style: {"gap":"4px"}
}
const _hoisted_49 = { class: "font-bold" }
const _hoisted_50 = {
  class: "flex-container-col",
  style: {"gap":"4px"}
}
const _hoisted_51 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_indicator = _resolveComponent("indicator")!
  const _component_purchase_button = _resolveComponent("purchase-button")!
  const _component_material_picture = _resolveComponent("material-picture")!
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_scroll_arrows = _resolveComponent("scroll-arrows")!
  const _component_card = _resolveComponent("card")!
  const _component_loader_guard = _resolveComponent("loader-guard")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_order_proposal_url_dialog = _resolveComponent("order-proposal-url-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loader_guard, { "has-loaded": _ctx.hasLoaded }, {
      default: _withCtx(() => [
        (_ctx.isNamedMode && _ctx.proposalError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_my_icon, {
                icon: "warning",
                size: 48
              }),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.localize('OrderProposalNotFound')), 1)
            ]))
          : (!_ctx.isNamedMode && _ctx.gridData.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_my_icon, {
                  icon: "cart",
                  size: 48
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.localize('emptyShoppingCart')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.isNamedMode && _ctx.orderProposal?.isExpired)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_my_icon, {
                        icon: "warning",
                        size: 24,
                        color: "#b71c1c"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.localize('OrderProposalExpiredWarning')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_card, {
                  ref: "cartCardRef",
                  class: "shopping-cart-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_icon, {
                          icon: "cart",
                          size: 20
                        }),
                        _createVNode(_component_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.cardTitle), 1)
                          ]),
                          _: 1
                        }),
                        (!_ctx.isNamedMode && _ctx.isAdmin && _ctx.gridData.length > 0 && !_ctx.isNarrowScreen)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "pill-button pill-button-filled",
                              style: {"margin-left":"auto"},
                              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showCreateProposalDialog && _ctx.showCreateProposalDialog(...args)), ["prevent"]))
                            }, [
                              _hoisted_7,
                              _createTextVNode(" " + _toDisplayString(_ctx.localize('SaveAsOrderProposal')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isNamedMode && _ctx.isAdmin && _ctx.orderProposal != null)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "pill-button",
                              style: {"margin-left":"auto"},
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showProposalUrlDialog && _ctx.showProposalUrlDialog(...args)), ["prevent"]))
                            }, [
                              _hoisted_8,
                              _createTextVNode(" " + _toDisplayString(_ctx.localize('ShowLinkForOrderProposal')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isNamedMode && _ctx.isNarrowScreen)
                          ? (_openBlock(), _createBlock(_component_k_button, {
                              key: 2,
                              class: "button-delete",
                              icon: "delete",
                              style: {"margin-left":"auto"},
                              disabled: _ctx.isUpdating,
                              onClick: _ctx.showResetCartConfirmation
                            }, null, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card_body, { style: {"padding":"4px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_grid, {
                          data: _ctx.gridData,
                          columns: _ctx.gridColumns,
                          sortable: false,
                          filterable: false,
                          groupable: false,
                          resizable: false
                        }, {
                          customTemplate1: _withCtx(({props}) => [
                            (props.field === 'selected')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (!props.dataItem.isIncludedPart)
                                    ? (_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        type: "checkbox",
                                        checked: props.dataItem.selected,
                                        onChange: ($event: any) => (_ctx.toggleSelection(props.dataItem))
                                      }, null, 40, _hoisted_10))
                                    : _createCommentVNode("", true)
                                ]))
                              : (props.field == 'shortText')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    style: _normalizeStyle(`color: ${ props.dataItem.isIncludedPart ? 'gray' : 'black' }`)
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["flex-container-row", _ctx.isNarrowScreen ? 'align-start' : 'align-center'])
                                    }, [
                                      (props.dataItem.isIncludedPart)
                                        ? (_openBlock(), _createBlock(_component_indicator, {
                                            key: 0,
                                            class: "included-part-badge",
                                            style: {"margin-left":"15px"},
                                            text: _ctx.localize('IncludedPart')
                                          }, null, 8, ["text"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.jumpToDetails(props.dataItem.materialNumber)),
                                        class: "cart-description-link"
                                      }, _toDisplayString(props.dataItem[props.field]), 9, _hoisted_11)
                                    ], 2),
                                    (props.dataItem.serialNumbers)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.getSerialNumberText(props.dataItem)), 1))
                                      : _createCommentVNode("", true)
                                  ], 4))
                                : (props.field == 'countText')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      (_ctx.isNamedMode)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(props.dataItem.count) + " " + _toDisplayString(props.dataItem.countUnitText), 1))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_purchase_button, {
                                              "material-number": props.dataItem.materialNumber,
                                              "fixed-count": props.dataItem.isIncludedPart ? props.dataItem.count : null
                                            }, null, 8, ["material-number", "fixed-count"]),
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(props.dataItem.countUnitText), 1)
                                          ], 64))
                                    ]))
                                  : (props.field === 'picture')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        (props.dataItem.materialDTO)
                                          ? (_openBlock(), _createBlock(_component_material_picture, {
                                              key: 0,
                                              "material-data": props.dataItem.materialDTO,
                                              "max-height": 80,
                                              "with-border": false,
                                              "show-hints": false,
                                              "lazy-load": true
                                            }, null, 8, ["material-data"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (props.field === 'materialNumber')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 4,
                                          class: "grid-id-link",
                                          onClick: ($event: any) => (_ctx.jumpToDetails(props.dataItem.materialNumber))
                                        }, _toDisplayString(props.dataItem[props.field]), 9, _hoisted_17))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 5,
                                          style: _normalizeStyle(`color: ${ props.dataItem.isIncludedPart ? 'gray' : 'black' }`)
                                        }, _toDisplayString(props.dataItem[props.field]), 5))
                          ]),
                          customTemplate2: _withCtx(({props}) => [
                            _createElementVNode("div", {
                              class: "flex-container-col gap5",
                              style: _normalizeStyle(`color: ${ props.dataItem.isIncludedPart ? 'gray' : 'black' }`)
                            }, [
                              (_ctx.isNamedMode && !props.dataItem.isIncludedPart)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: props.dataItem.selected,
                                      onChange: ($event: any) => (_ctx.toggleSelection(props.dataItem))
                                    }, null, 40, _hoisted_19),
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.localize('Select')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.dataItem.isIncludedPart)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_indicator, {
                                      class: "included-part-badge",
                                      text: _ctx.localize('IncludedPart')
                                    }, null, 8, ["text"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "flex-container-row gap10 align-start",
                                style: _normalizeStyle(props.dataItem.isIncludedPart ? 'margin-left: 15px' : '')
                              }, [
                                (props.dataItem.materialDTO)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createVNode(_component_material_picture, {
                                        "material-data": props.dataItem.materialDTO,
                                        "max-height": 72,
                                        "with-border": false,
                                        "show-hints": false,
                                        "lazy-load": true
                                      }, null, 8, ["material-data"])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.localize('material')) + ": ", 1)
                                    ]),
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (_ctx.jumpToDetails(props.dataItem.materialNumber)),
                                      class: "cart-description-link"
                                    }, [
                                      _createElementVNode("span", _hoisted_28, _toDisplayString(props.dataItem.materialNumber), 1),
                                      _createTextVNode(" " + _toDisplayString(props.dataItem.shortText), 1)
                                    ], 8, _hoisted_27)
                                  ]),
                                  (props.dataItem.partnerMaterialNo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.localize('ownMaterialNo')) + ": " + _toDisplayString(props.dataItem.partnerMaterialNo), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.isNamedMode || props.dataItem.isIncludedPart)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.localize('qty')) + ": ", 1),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", null, _toDisplayString(props.dataItem.count) + " " + _toDisplayString(props.dataItem.countUnitText), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(_component_purchase_button, {
                                          "material-number": props.dataItem.materialNumber,
                                          "fixed-count": null
                                        }, null, 8, ["material-number"]),
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(props.dataItem.countUnitText), 1)
                                      ])),
                                  (props.dataItem.serialNumbers)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.getSerialNumberText(props.dataItem)), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.showPrices && !props.dataItem.isIncludedPart)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.localize('price')) + " / " + _toDisplayString(_ctx.localize('amount')) + ": ", 1),
                                        _createElementVNode("div", null, _toDisplayString(props.dataItem.priceText) + " / " + _toDisplayString(props.dataItem.amountText), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 4)
                            ], 4)
                          ]),
                          _: 1
                        }, 8, ["data", "columns"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_scroll_arrows, {
                      "container-ref": _ctx.cartCardRef,
                      "scroll-selector": ".k-grid-content",
                      trigger: _ctx.gridData
                    }, null, 8, ["container-ref", "trigger"]),
                    (_ctx.showPrices)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.localize('totalAmount')), 1),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.totalPriceText), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512),
                (!_ctx.isNamedMode)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["flex-item flex-container-row flex-wrap shopping-cart-actions", [_ctx.isNarrowScreen ? 'gap5 cart-actions-narrow' : 'gap10']])
                    }, [
                      (!_ctx.isNarrowScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createVNode(_component_k_button, {
                              class: "button-delete",
                              icon: "delete",
                              onClick: _ctx.showResetCartConfirmation,
                              disabled: _ctx.isUpdating
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('resetShoppingCart')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.showPrices)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.showPrices && !_ctx.isNarrowScreen ? 'flex-grow: 1' : '')
                      }, [
                        _createVNode(_component_k_button, {
                          icon: "email",
                          onClick: _ctx.showSendCartConfirmation,
                          disabled: _ctx.isUpdating
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('SendCart')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ], 4),
                      (_ctx.showPrices && _ctx.isNarrowScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                        : _createCommentVNode("", true),
                      (_ctx.showPrices)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createVNode(_component_k_button, {
                              icon: "cart",
                              onClick: _ctx.onCheckout,
                              disabled: _ctx.isUpdating
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('toCheckOut')) + "...", 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["flex-item flex-container-row flex-wrap shopping-cart-actions", [_ctx.isNarrowScreen ? 'gap5 cart-actions-narrow' : 'gap10']])
                    }, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_k_button, {
                          icon: "email",
                          onClick: _ctx.showSendCartConfirmation,
                          disabled: _ctx.isUpdating
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('SendCart')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]),
                      _hoisted_44,
                      _createElementVNode("div", null, [
                        _createVNode(_component_k_button, {
                          icon: "cart",
                          onClick: _ctx.onAddToMyCart,
                          disabled: _ctx.isUpdating || _ctx.selectedItemCount === 0
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.addToMyCartText), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ], 2))
              ]))
      ]),
      _: 1
    }, 8, ["has-loaded"]),
    (_ctx.isResetCartConfirmationVisible)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 0,
          title: _ctx.localize('PleaseConfirm'),
          onClose: _ctx.closeResetCartConfirmation
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.localize('ConfirmResetCart')), 1),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "button-cancel",
                  onClick: _ctx.closeResetCartConfirmation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('no')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, { onClick: _ctx.onResetCart }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('yes')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isSendCartConfirmationVisible)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 1,
          title: _ctx.localize('PleaseConfirm'),
          onClose: _ctx.closeSendCartConfirmation
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.sendByEmailConfirmationText), 1),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "button-cancel",
                  onClick: _ctx.closeSendCartConfirmation
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('no')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, { onClick: _ctx.onSendCart }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('yes')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isCreateProposalDialogVisible)
      ? (_openBlock(), _createBlock(_component_app_dialog, {
          key: 2,
          title: _ctx.localize('SaveAsOrderProposal'),
          onClose: _ctx.closeCreateProposalDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.localize('OrderProposalName')) + "*", 1),
                _createVNode(_component_k_input, {
                  value: _ctx.createProposalName,
                  maxlength: '255',
                  class: "fw",
                  onInput: _cache[2] || (_cache[2] = (e) => _ctx.createProposalName = e.value)
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.localize('ValidUntil')) + "*", 1),
                _createVNode(_component_date_picker, {
                  value: _ctx.createProposalExpDate,
                  min: _ctx.minCreateProposalDate,
                  format: _ctx.kendoDateFormat,
                  class: "fw",
                  onChange: _cache[3] || (_cache[3] = (e) => _ctx.createProposalExpDate = e.value)
                }, null, 8, ["value", "min", "format"])
              ])
            ]),
            _createVNode(_component_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "button-cancel",
                  onClick: _ctx.closeCreateProposalDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, {
                  class: "button-save",
                  onClick: _ctx.onCreateProposal,
                  icon: "save",
                  disabled: !_ctx.isCreateProposalValid || _ctx.isUpdating
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.createdProposalCartId != null)
      ? (_openBlock(), _createBlock(_component_order_proposal_url_dialog, {
          key: 3,
          "order-proposal-no": _ctx.createdProposalOrderProposalNo,
          name: _ctx.createdProposalName,
          "cart-id": _ctx.createdProposalCartId,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createdProposalCartId = null))
        }, null, 8, ["order-proposal-no", "name", "cart-id"]))
      : _createCommentVNode("", true),
    (_ctx.isProposalUrlDialogVisible && _ctx.orderProposal != null)
      ? (_openBlock(), _createBlock(_component_order_proposal_url_dialog, {
          key: 4,
          "order-proposal-no": _ctx.orderProposal.orderProposalNo,
          name: _ctx.orderProposal.name,
          "cart-id": _ctx.orderProposal.id,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isProposalUrlDialogVisible = false))
        }, null, 8, ["order-proposal-no", "name", "cart-id"]))
      : _createCommentVNode("", true)
  ]))
}